module.exports = __webpack_public_path__ + "static/img/xjzd.913498f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xjzd.png
// module id = o6GT
// module chunks = 1